import React from 'react';
import component, {classnames} from './component';

export default component('League', function({className, league, withText=false}) {
  if(!league || !league.get('visible')) return null;
  return (
    <div className={classnames(className, 'League')}>
      <div className="League-Logo" style={{backgroundImage: `url(${league.get('logo')})`}}/>
      {withText && <span className="League-Text">{league.get('name')}</span> || ''
      }
    </div>
  );
});



// WEBPACK FOOTER //
// ./src/components/League.js